import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

import frCompanies from './locales/companies/fr.json';
import enCompanies from './locales/companies/en.json';

import frInfrastructure from './locales/infrastructure/fr.json';
import enInfrastructure from './locales/infrastructure/en.json';
import arInfrastructure from './locales/infrastructure/ar.json';
import arCompanies from './locales/companies/ar.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        translation: fr,
        companies: frCompanies,
        infrastructure: frInfrastructure
      },
      en: {
        translation: en,
        companies: enCompanies,
        infrastructure: enInfrastructure
      },
      ar: {
        translation: ar,
        companies: arCompanies,
        infrastructure: arInfrastructure
      },
    },
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

// Handle RTL
i18n.on('languageChanged', (lng) => {
  const direction = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = direction;
  document.documentElement.lang = lng;
});

// Initial set
const initialDirection = i18n.language === 'ar' ? 'rtl' : 'ltr';
if (typeof document !== 'undefined') {
  document.documentElement.dir = initialDirection;
  document.documentElement.lang = i18n.language || 'fr';
}

export default i18n;
